import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import { selectCompanyFilter } from 'containers/PartnerOptions/selectors'
import { incidentsCountPolling } from 'containers/Polling/actions'

import App from 'components/pages/App'

import * as actions from './actions'
import {
  selectActualMailboxEnabled,
  selectActualMailboxLimit,
  selectEnvironment,
  selectError,
  selectIsDataLoaded,
  selectIsMaster,
  selectIsStaticSalesDemo,
  selectRegion,
  selectSelfBrandName,
  selectSelfCompanyId,
  selectSelfCompanyName,
  selectSelfIntegrations,
  selectSelfIsPartner,
  selectSelfLicenses,
  selectSelfOwnerStatus,
  selectSelfPartnerName,
  selectUser,
} from './selectors'

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...actions,
      incidentsCountPolling,
    },
    dispatch
  )

const mapStateToProps = (state) => ({
  error: selectError(state),
  isDataLoaded: selectIsDataLoaded(state),
  isMaster: selectIsMaster(state),
  isOwner: selectSelfOwnerStatus(state),
  selfCompanyId: selectSelfCompanyId(state),
  selfCompanyName: selectSelfCompanyName(state),
  selfIntegrations: selectSelfIntegrations(state),
  selfLicenses: selectSelfLicenses(state),
  isPartner: selectSelfIsPartner(state),
  partnerName: selectSelfPartnerName(state),
  brandName: selectSelfBrandName(state),
  user: selectUser(state),
  companyFilter: selectCompanyFilter(state),
  mailboxLimit: selectActualMailboxLimit(state),
  mailboxEnabled: selectActualMailboxEnabled(state),
  isStaticSalesDemo: selectIsStaticSalesDemo(state),
  region: selectRegion(state),
  environment: selectEnvironment(state),
})

const render = connect(mapStateToProps, mapDispatchToProps)(App)

export default withRouter(render)
